<div class="full_dialog">
    <div class="head_content">
        <h2>{{"quotations_and_orders.preview_invoice_request_document" | translate}}.pdf</h2>
        <mat-icon (click)="close()">close</mat-icon>
    </div>
    <div class="document">
        <object *ngIf="pdfUrl" type="application/pdf" [data]="pdfUrl" width="100%" height="600px"></object>
    </div>
</div>
